export var UserLocalStorageKey = '@Ent-games:user';
export var TokenLocalStorageKey = '@Ent-games:token';
